<template>
  <smd-one-col-layout>
    <div class="smd-form__row">
      <text-string label-id="txt055"/>
    </div>
    <div class="smd-form__row">
      <smd-textarea v-model="message"/>
    </div>
    <div class="smd-form__row flex-row-center-xy-spaced">
      <smd-btn section="4"
               variant="unselected"
               @click="closeModal">
        <text-string label-id="txt261"/>
      </smd-btn>
      <smd-btn section="4"
               :variant="submitBtnVariant"
               :disabled="messageIsEmpty"
               @click="submit">
        <text-string label-id="txt575"/>
      </smd-btn>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {MedicineService} from "@/services/medicine";
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import getElementStringMixin from '@/mixins/get-element-string';
  import ToastMixin from '@/mixins/toast-mixin';

  export default {
    name: "modal-suggest-service",
    mixins: [
      getElementStringMixin,
      CloseModalMixin,
      ToastMixin
    ],
    data() {
      return {
        message: ''
      }
    },
    computed: {
      submitBtnVariant() {
        return this.message === '' ? 'blue-disabled' : 'blue-enabled'
      },
      messageIsEmpty() {
        return this.message === '';
      }
    },
    methods: {
      async submit() {
        if (!this.messageIsEmpty)
          try {
            await MedicineService.suggestService({remarks: this.message});
            this.showToast({
              text: this.getElementString('txt216'),
              theme: 'success'
            })
            this.closeModal();
          } catch (error) {
            this.closeModal();
            console.log(error)
          }
      }
    }
  }
</script>

<style scoped>

</style>